var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Render',{attrs:{"options":_vm.preview.jsonSchema,"form-guid":_vm.formGuid,"is-preview":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }